var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulbOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_lighBlub)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.09 16.707a.399.399 0 00-.146.546l.4.694a.4.4 0 00.546.146l4.961-2.864a10.35 10.35 0 01-.9-1.327L2.09 16.707zM5.617 8.8H.4a.4.4 0 00-.4.4v.8a.4.4 0 00.4.4h5.326a10.578 10.578 0 01-.11-1.6zM2.09 2.492l4.258 2.459c.199-.5.436-.979.708-1.438L2.89 1.107a.4.4 0 00-.546.147l-.4.692a.4.4 0 00.146.547zm27.82 0a.4.4 0 00.146-.546l-.4-.693a.399.399 0 00-.546-.146l-4.169 2.407c.272.458.512.936.712 1.436l4.257-2.458zM31.6 8.8h-5.2c0 .54-.063 1.072-.145 1.6H31.6a.4.4 0 00.4-.4v-.8a.4.4 0 00-.4-.4zm-1.69 7.907l-4.87-2.812c-.262.466-.572.902-.906 1.325l4.976 2.873a.4.4 0 00.547-.147l.4-.693a.4.4 0 00-.147-.546zM16 3.2a5.607 5.607 0 00-5.6 5.6.8.8 0 101.6 0c0-2.206 1.794-4 4-4a.8.8 0 100-1.6zM16 0c-5.148 0-8.806 4.177-8.8 8.812a8.75 8.75 0 002.178 5.777c1.283 1.463 2.514 3.845 2.622 4.611l.003 3.759a.8.8 0 00.134.442l1.226 1.842a.8.8 0 00.665.357h3.943a.8.8 0 00.666-.357l1.226-1.842a.804.804 0 00.134-.442L20 19.2c.113-.786 1.35-3.16 2.622-4.611A8.75 8.75 0 0024.8 8.8 8.8 8.8 0 0016 0zm2.397 22.715L17.543 24h-3.086l-.855-1.285V22.4h4.795v.316zm.002-1.915H13.6l-.003-1.6h4.804l-.002 1.6zm3.02-7.266c-.7.798-1.817 2.405-2.529 4.065h-5.78c-.712-1.66-1.829-3.267-2.528-4.065A7.175 7.175 0 018.802 8.8C8.795 4.95 11.822 1.6 16 1.6c3.97 0 7.2 3.23 7.2 7.2a7.179 7.179 0 01-1.781 4.734z",
    fill: "var(--color-tertiary)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_lighBlub"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v25.6H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbOn);
export default __webpack_public_path__ + "static/media/lightbulb-on.dad18ae4f38b906e09f2ad06f5ce000a.svg";
export { ForwardRef as ReactComponent };